import { useState, useEffect } from "react";
import {
  Button,
  Stack,
  Typography,
  FormControlLabel,
  Checkbox,
  CardContent,
  Card,
  Box,
  Modal,
} from "@mui/material";
import { connect } from "react-redux";
import {  useNavigate } from "react-router-dom";
import { getAllSelfEvalTest, submitMCQ } from "../../redux/actions/dashboard";
import { getSelfEvalTestEmployee, submitMcqEmployee } from "../../services/dashboard";
import AlertDialog from "../../components/Dialog";
import Loader from "../../components/Loader";
const modalPopUpStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 300,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  borderRadius: '8px',
  textAlign: 'center',
};

const percentageStyle = (isPassing) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  width: '100px',
  height: '100px',
  backgroundColor: isPassing ? 'green' : 'red',
  color: 'white',
  fontSize: '24px',
  fontWeight: 'bold',
  margin: '20px 0',
});

export const TestPage = ({
  // dashboard: { test },
  // getAllSelfEvalTest,
  // submitMCQ,
  testResult,
  skillData
}) => {
  const navigate = useNavigate();
  const [answerSheet, setAnswerSheet] = useState([]);
  const [openSecond, setOpenSecond] = useState(false);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [isPassing, setIsPassing] = useState(0);
  const [returnOfSubmit, setReturnOfSubmit] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [test, setTest]=useState(null);

  const toggleModalOpen = () => {
    setOpenSecond(true);
  };

  const onClickAnswer = (e, q_id, opt) => {
    if (answerSheet.find((ans) => ans.q_id === q_id)) {
      if (answerSheet.find((ans) => ans.q_id === q_id && ans.answer === opt)) {
        let tempArray = answerSheet.filter((ans) => ans.q_id !== q_id);
        setAnswerSheet(tempArray);
      } else {
        let tempArray = answerSheet.map((ans) => {
          return ans.q_id === q_id ? { ...ans, answer: opt } : ans;
        });
        setAnswerSheet(tempArray);
      }
    } else {
      let obj = {
        q_id: q_id,
        answer: opt,
      };
      setAnswerSheet([...answerSheet, obj]);
    }
  };

  useEffect(() => {
    if (!skillData) {
      skillData = JSON.parse(localStorage.getItem('skillData'));
    }
  }, [skillData]);

  useEffect(() => {
    const fetchTest = async ()=> {
      if (skillData && skillData.length) {
        setSubmitting(true);
        let testData = await getSelfEvalTestEmployee({ skills: skillData }, "mcq");
        setTest(testData);
        setSubmitting(false);
      }
    }
    fetchTest();
  }, [skillData]);

  useEffect(() => {
    if (confirm) {
      submitFinalData();
    }
  }, [confirm]);

  const submitFinalData = async () => {
    setSubmitting(true);
    let data = {
      skills: skillData,
      totalQues: test.length,
      answerSheetMCQ: answerSheet,
    };
    await submitMcqEmployee(data);
    setOpen(false);
    setConfirm(false);
    setSubmitting(false);
    handleSubmit();
  };

  const submitData = () => {
    setTitle("Submit Test");
    setContent("Are you sure you want to submit the test?");
    setOpen(true);
  };

  const handleSubmit = () => {
    setOpenSecond(false);
    navigate('/employee/self-assessment/coding', { replace: true });
  }

  // useEffect(() => {
  //   return () => {
  //     if (openSecond) {
  //       setOpenSecond(false);
  //     }
  //   };
  // }, [navigate]);
  useEffect(() => {
    if (testResult) {
      toggleModalOpen();

      const isPassings = testResult && testResult?.finalPercentage > 50;
      setIsPassing(isPassings);
    }
  }, [testResult]);

  return (
    <>
      {submitting ?<Loader />:<CardContent>
        <Stack direction="column" alignItems="center" spacing={3}>
          <Box component="main" sx={{ width: "100%" }}>
            {returnOfSubmit && <h1>{returnOfSubmit.finalPercentage}</h1>}
            <AlertDialog
              open={open}
              setOpen={setOpen}
              title={title}
              setConfirm={setConfirm}
              content={content}
            />
            <Stack
              direction={{ xs: "column", sm: "column" }}
              spacing={2}
              sx={{ width: "100%" }}
            >
              <Card sx={{ mb: 2 }}>
                <CardContent>
                  <Stack direction="column">
                    <Typography variant="h6" sx={{ textAlign: "center" }}>
                      MCQ Test
                    </Typography>
                  </Stack>
                </CardContent>
              </Card>
              {test &&
                test.length > 0 &&
                test.map((item, index) => (
                  <Card key={index} sx={{ mb: 2 }}>
                    <CardContent>
                      <Typography variant="h6">
                        {index + 1}. {item.q_name}
                      </Typography>
                      <Stack direction="column">
                        {item?.options?.map((opt, idx) => (
                          <FormControlLabel
                            key={opt.a_id}
                            control={
                              <Checkbox
                                color="primary"
                                checked={
                                  answerSheet &&
                                  answerSheet.find(
                                    (ans) =>
                                      ans.q_id === item.q_id &&
                                      ans.answer === opt.a_label
                                  )
                                    ? true
                                    : false
                                }
                              />
                            }
                            label={opt.a_text}
                            onClick={(e) =>
                              onClickAnswer(e, item.q_id, opt.a_label)
                            }
                          />
                        ))}
                      </Stack>
                    </CardContent>
                  </Card>
                ))}
              <Card sx={{ mb: 2 }}>
                <CardContent>
                  <Stack direction="column">
                    <Box component="footer" sx={{ width: "100%" }}>
                      <Stack
                        direction="row"
                        sx={{
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          color="primary"
                          component="label"
                          variant="contained"
                          tabIndex={-1}
                          onClick={() => navigate(-1)}
                        >
                          Back
                        </Button>
                        <Button
                          color="primary"
                          component="label"
                          variant="contained"
                          tabIndex={-1}
                          onClick={submitData}
                          disabled={answerSheet.length === 0}
                        >
                          Submit
                        </Button>
                      </Stack>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Stack>
          </Box>
        </Stack>
      </CardContent>}
      <Modal
        open={openSecond}
        onClose={() => {}}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={modalPopUpStyle}>
          <Typography variant="h6" component="h2" id="child-modal-title">
            Your Score is
          </Typography>
          {testResult && (
            <>
              <Box sx={percentageStyle(isPassing)}>
                {testResult.finalPercentage}%
              </Box>
              <Typography>Total Question: 20</Typography>
              <Typography>
                Total Attempted Question :{" "}
                {testResult.totalAttemptedFinale / skillData?.length}
              </Typography>
              <Typography>
                Total Correct Question: {testResult.totalCorrect}
              </Typography>
            </>
          )}
          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              color={isPassing ? "success" : "error"}
              onClick={handleSubmit}
            >
              OK
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  dashboard: state.dashboard,
  skillData: state.skills.data,
  testResult: state.dashboard.testResult,
});

const mapDispatchToProps = {
  // getAllSelfEvalTest,
  // submitMCQ,
};

export default connect(mapStateToProps, mapDispatchToProps)(TestPage);
